import { render, staticRenderFns } from "./Keyboard.vue?vue&type=template&id=6a42f9da&scoped=true&"
import script from "./Keyboard.vue?vue&type=script&lang=js&"
export * from "./Keyboard.vue?vue&type=script&lang=js&"
import style0 from "./Keyboard.vue?vue&type=style&index=0&id=6a42f9da&lang=scss&scoped=true&"
import style1 from "./Keyboard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a42f9da",
  null
  
)

export default component.exports